module.exports = __webpack_public_path__ + "images/lvyue1.jpg?v=4ebdce40";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/lvyue1.jpg
 ** module id = 111
 ** module chunks = 1 2
 **/